// Default Suffixes for all types
export const REQUEST = '_REQUEST';
export const SUCCESS = '_SUCCESS';
export const REJECTED = '_REJECTED';